import { parsePhoneNumberFromString } from 'libphonenumber-js'

const COUNTRY_NAME_OVERRIDES = {
  US: 'USA'
}

let displayNames

function getRegionDisplayNames() {
  if (displayNames) return displayNames
  if (typeof Intl === 'undefined' || typeof Intl.DisplayNames !== 'function') {
    return null
  }

  try {
    displayNames = new Intl.DisplayNames(['en'], { type: 'region' })
  } catch (error) {
    displayNames = null
  }

  return displayNames
}

export function getCountryNameFromCountryCode(countryCode) {
  if (typeof countryCode !== 'string' || countryCode.trim().length === 0) {
    return ''
  }

  if (COUNTRY_NAME_OVERRIDES[countryCode]) {
    return COUNTRY_NAME_OVERRIDES[countryCode]
  }

  const regionDisplayNames = getRegionDisplayNames()
  if (!regionDisplayNames) {
    return countryCode
  }

  return regionDisplayNames.of(countryCode) || countryCode
}

export function getCountryNameFromPhoneNumber(cellnumber) {
  if (typeof cellnumber !== 'string') {
    return ''
  }

  const trimmedCellnumber = cellnumber.trim()
  if (trimmedCellnumber.length === 0) {
    return ''
  }

  try {
    const phoneNumber = parsePhoneNumberFromString(trimmedCellnumber)
    if (!phoneNumber || !phoneNumber.country) {
      return ''
    }

    return getCountryNameFromCountryCode(phoneNumber.country)
  } catch (error) {
    return ''
  }
}
